import { FormGroup } from '@angular/forms';

export class MatchPassword {
    static MatchPassword(registrationFormGroup: FormGroup) {
        const currentPassword = registrationFormGroup.controls.CurrentPassword.value;
        const newPassword = registrationFormGroup.controls.Password.value;
        const confirmPassword = registrationFormGroup.controls.ConfirmPassword.value;
        /** If current password field is not empty and new password is not empty*/
            if (currentPassword !== '' && newPassword !== '') {
                if (currentPassword === newPassword) {
                    registrationFormGroup.controls.Password.setErrors({ MatchPassword: true });
                    registrationFormGroup.controls['Password'].markAsTouched();
                }
                if (currentPassword !== newPassword) {
                    registrationFormGroup.controls['CurrentPassword'].markAsUntouched();
                    registrationFormGroup.controls.CurrentPassword.setErrors(null);
                    registrationFormGroup.controls['Password'].markAsUntouched();
                    registrationFormGroup.controls.Password.setErrors(null);
            }
            } /** If current password field is empty and new password is empty*/else if (currentPassword === '' && newPassword === '') {
                registrationFormGroup.controls.Password.setErrors({ MatchPassword: false });
                registrationFormGroup.controls['Password'].markAsTouched();
            } /** If current password field is not empty and new password is empty*/else if (currentPassword !== '' && newPassword === '') {
            registrationFormGroup.controls.Password.setErrors({ MatchPassword: false });
            registrationFormGroup.controls['Password'].markAsTouched();
        } /** If current password field is empty and new password is not empty*/  else if (currentPassword === '' && newPassword !== '') {
            registrationFormGroup.controls.CurrentPassword.setErrors({ MatchPassword: true });
            registrationFormGroup.controls['CurrentPassword'].markAsTouched();
            registrationFormGroup.controls.Password.setErrors(null);
                    registrationFormGroup.controls['Password'].markAsUntouched();
        }
        /** If current password , new password and confirm password all are empty */
        if (currentPassword === ''  && newPassword === '' && confirmPassword === '') {
            registrationFormGroup.controls.CurrentPassword.setErrors(null);
            registrationFormGroup.controls['CurrentPassword'].markAsUntouched();
            registrationFormGroup.controls.Password.setErrors(null);
            registrationFormGroup.controls['Password'].markAsUntouched();
            registrationFormGroup.controls.ConfirmPassword.setErrors(null);
            registrationFormGroup.controls['ConfirmPassword'].markAsUntouched();
           }
            /** If new password is not equal to confirm password */
         if (newPassword !== confirmPassword) {
            registrationFormGroup.controls.ConfirmPassword.setErrors({ MatchPassword: true });
            registrationFormGroup.controls['ConfirmPassword'].markAsTouched();
        } else {
            registrationFormGroup.controls.ConfirmPassword.setErrors(null);
            registrationFormGroup.controls['ConfirmPassword'].markAsUntouched();
        }
    }
}
